import {extendTheme} from 'native-base';

export const theme = extendTheme({
  fontConfig: {
    Poppins: {
      50: {
        normal: 'Poppins',
      },
      100: {
        normal: 'Poppins',
      },
      200: {
        normal: 'Poppins',
        italic: 'Poppins-Italic',
        bold: 'Poppins-Bold',
        extrabold: 'Poppins-Extra-Bold',
        extrablack: 'Poppins-Extra-Bold',
      },
      300: {
        normal: 'Poppins',
        italic: 'Poppins-Italic',
        bold: 'Poppins-Bold',
        extrabold: 'Poppins-Extra-Bold',
        extrablack: 'Poppins-Extra-Bold',
      },
      400: {
        normal: 'Poppins',
        italic: 'Poppins-Italic',
        bold: 'Poppins-Bold',
        extrabold: 'Poppins-Extra-Bold',
        extrablack: 'Poppins-Extra-Bold',
      },
      500: {
        normal: 'Poppins',
        italic: 'Poppins-Italic',
        bold: 'Poppins-Bold',
        extrabold: 'Poppins-Extra-Bold',
        extrablack: 'Poppins-Extra-Bold',
      },
      600: {
        normal: 'Poppins-Medium',
        italic: 'Poppins-Medium-Italic',
        bold: 'Poppins-Bold',
        extrabold: 'Poppins-Extra-Bold',
        extrablack: 'Poppins-Extra-Bold',
      },
      700: {
        normal: 'Poppins-Medium',
        italic: 'Poppins-Medium-Italic',
        bold: 'Poppins-Bold',
        extrabold: 'Poppins-Extra-Bold',
        extrablack: 'Poppins-Extra-Bold',
      },
      800: {
        normal: 'Poppins-Bold',
        italic: 'Poppins-Bold-Italic',
        bold: 'Poppins-Bold',
        extrabold: 'Poppins-Extra-Bold',
        extrablack: 'Poppins-Extra-Bold',
      },
      900: {
        normal: 'Poppins-Medium',
        italic: 'Poppins-Medium-Italic',
        bold: 'Poppins-Bold',
        extrabold: 'Poppins-Extra-Bold',
        extrablack: 'Poppins-Extra-Bold',
      },
    },
  },
  fonts: {
    heading: 'Poppins',
    body: 'Poppins',
    mono: 'Poppins',
    customFont: 'Poppins',
  },
});
